<template>
  <BaseFormInput
    v-bind="$attrs"
    v-on="$listeners"
    :label-text="labelText"
    :value="formattedValue"
    @update="onUpdate"
  />
</template>

<script>
import BaseFormInput from "@/components/base/BaseFormInput.vue";
import { formatDocument, normalizeCpf, normalizeCnpj, detectDocumentType } from "@/utils/documents.js";

export default {
  name: "DocumentInput",
  inheritAttrs: false,
  components: {
    BaseFormInput
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    labelText: {
      type: String,
      default: ""
    },
    documentType: {
      type: String,
      default: "hybrid"
    }
  },
  computed: {
    formattedValue() {
      return formatDocument(this.value);
    }
  },
  methods: {
    onUpdate(value) {
      const type = this.documentType === "hybrid" ? detectDocumentType(value) : this.documentType;
      const normalized = type === "cpf" ? normalizeCpf(value) : normalizeCnpj(value);
      this.$emit("update", formatDocument(normalized));
    }
  }
};
</script>
